import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';

const CurrentAdtrAuthorizations = forwardRef((props, ref) => {
  const {onDataFetch, reportId} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [adtrAuthorizations, setAdtrAuthorizations] = useState([]); //Existing adtr authorizations in ADTR Authorization table
  

  useEffect(() => {
    if (reportId){
      getAuthorizationsByRFSId(reportId);
    }
   
  }, [reportId]);


  const getAuthorizationsByRFSId = (selectedFinalSaleId) => {
    var obj = {
      msgId: null,
      sysId: null,
      opr: "getAdtrAuthorizationsByFinalSale",
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "finalSaleId": selectedFinalSaleId,
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setAdtrAuthorizations(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);
      });
  }

  
  useImperativeHandle(ref, () => {
      return {
        getAuthorizationsByRFSId
      };
  }, [])
  

  const columnsAdtrAuthorizations = [{
    dataField: 'fiscalYrEndDate',
    text: 'Fiscal Year End Date',
    sort: true,
    formatter: (row)=> CommonService.dateFormatter(row.fiscalYrEndDate),
  }, {
    dataField: 'authorizationName',
    text: 'Authorization Name',
    sort: true,
  }, 
  {
    dataField: 'beginAmt',
    text: 'Begin Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.beginAmt),
  }, {
    dataField: 'duringAmt',
    text: 'During Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.duringAmt),
  }, {
    dataField: 'authorityReducedAmt',
    text: 'Authority Reduced Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReducedAmt),
  }, {
    dataField: 'authorityReplenishAmt',
    text: 'Authority Replenish Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.authorityReplenishAmt),
  }, {
    dataField: 'lapsedAmt',
    text: 'Lapsed Amount',
    sort: true,
    formatter: (row)=> CommonService.currencyFormatter(row.lapsedAmt),
  }
  ];


  return (
    <div>
      <DataGrid
        title="Current ADTR Authorizations:"
        dataSource={adtrAuthorizations}
        sortField='fiscalYrEndDate'
        sortOrder={1}
        showQuickSearch={false}
        emptyDataMessage='No data available to display'
      >
        {columnsAdtrAuthorizations.map((column, i) => {
          return (
            <Column
              key={i}
              field={column.dataField}
              header={column.text}
              body={column.formatter}
              hidden={column.hidden}
            />)
        })
        }
      </DataGrid>
    </div>

  )
});

export default CurrentAdtrAuthorizations;